import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uplift-report',
  templateUrl: './uplift-report.component.html',
  styleUrls: ['./uplift-report.component.scss']
})
export class UpliftReportComponent implements OnInit {

  searchText: string;
  data : any[];

  constructor() { }

  ngOnInit() {

    this.data = [
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/uplift_category_wise_report.xlsx",
        "State": "Consolidated Report",
        "Year": ""
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Jun.xlsx",
        "State": "Karnataka",
        "Year": "June 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Jul.xlsx",
        "State": "Karnataka",
        "Year": "July 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Aug.xlsx",
        "State": "Karnataka",
        "Year": "August 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Sep.xlsx",
        "State": "Karnataka",
        "Year": "September 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Oct.xlsx",
        "State": "Karnataka",
        "Year": "October 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Nov.xlsx",
        "State": "Karnataka",
        "Year": "November 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Karnataka-Dec20.xlsx",
        "State": "Karnataka",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-TE-Sep.xlsx",
        "State": "Telegana",
        "Year": "September 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-TE-Oct.xlsx",
        "State": "Telegana",
        "Year": "October 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-TE-Nov.xlsx",
        "State": "Telegana",
        "Year": "November 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-TE-Dec.xlsx",
        "State": "Telegana",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-MH-Sep.xlsx",
        "State": "Maharashtra",
        "Year": "September 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-MH-Oct.xlsx",
        "State": "Maharashtra",
        "Year": "October 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-MH-Nov.xlsx",
        "State": "Maharashtra",
        "Year": "November 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-MH-Dec.xlsx",
        "State": "Maharashtra",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-PY-Nov.xlsx",
        "State": "Pondicherry",
        "Year": "November 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-PY-Dec.xlsx",
        "State": "Pondicherry",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Goa-Nov.xlsx",
        "State": "Goa",
        "Year": "November 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-Goa-Dec.xlsx",
        "State": "Goa",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-WB-Dec.xlsx",
        "State": "West Bengal",
        "Year": "December 2020"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-KA-Jan21.xlsx",
        "State": "Karnataka",
        "Year": "January 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-PY-Jan21.xlsx",
        "State": "Pondicherry",
        "Year": "January 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-GOA-Jan21.xlsx",
        "State": "Goa",
        "Year": "January 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-MH-Jan21.xlsx",
        "State": "Maharashtra",
        "Year": "January 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/uplift/Uplift-Outlet-Wise-TE-Jan21.xlsx",
        "State": "Telegana",
        "Year": "January 2021"
      }
     ];

  }

}
